import { render, staticRenderFns } from "./ColaboradoresPontosAdminPage.vue?vue&type=template&id=593cfb75"
import script from "./ColaboradoresPontosAdminPage.vue?vue&type=script&lang=js"
export * from "./ColaboradoresPontosAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports